import { storableError } from '../../util/errors';
import { addMarketplaceEntities, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';

// ================ Action types ================ //
export const SET_INITIAL_VALUES = 'app/AdminTransactionDetailPage/SET_INITIAL_VALUES';

export const FETCH_TX_REQUEST = 'app/AdminTransactionDetailPage/FETCH_TX_REQUEST';
export const FETCH_TX_SUCCESS = 'app/AdminTransactionDetailPage/FETCH_TX_SUCCESS';
export const FETCH_TX_ERROR = 'app/AdminTransactionDetailPage/FETCH_TX_ERROR';

export const TRANSITION_REQUEST = 'app/AdminTransactionDetailPage/TRANSITION_REQUEST';
export const TRANSITION_SUCCESS = 'app/AdminTransactionDetailPage/TRANSITION_SUCCESS';
export const TRANSITION_ERROR = 'app/AdminTransactionDetailPage/TRANSITION_ERROR';

// ================ Reducer ================ //
const initialState = {
  transactionRef: null,
  fetchInProgress: false,
  fetchError: null,
  transitionInProgress: null, // the transition name currently running
  transitionError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case FETCH_TX_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_TX_SUCCESS:
      return { ...state, fetchInProgress: false, transactionRef: payload.ref };
    case FETCH_TX_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };

    case TRANSITION_REQUEST:
      return { ...state, transitionInProgress: payload, transitionError: null };
    case TRANSITION_SUCCESS:
      return { ...state, transitionInProgress: null };
    case TRANSITION_ERROR:
      return { ...state, transitionInProgress: null, transitionError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //
export const setInitialValues = values => ({ type: SET_INITIAL_VALUES, payload: values });

const fetchTxRequest = () => ({ type: FETCH_TX_REQUEST });
const fetchTxSuccess = ref => ({ type: FETCH_TX_SUCCESS, payload: { ref } });
const fetchTxError = e => ({ type: FETCH_TX_ERROR, error: true, payload: e });

const transitionRequest = name => ({ type: TRANSITION_REQUEST, payload: name });
const transitionSuccess = () => ({ type: TRANSITION_SUCCESS });
const transitionErrorAction = e => ({ type: TRANSITION_ERROR, error: true, payload: e });

// ================ Selectors ================ //
export const getTransaction = state => {
  const ref = state.AdminTransactionDetailPage?.transactionRef;
  if (!ref) return null;
  const entities = getMarketplaceEntities(state, [ref]);
  return entities.length === 1 ? entities[0] : null;
};

// ================ Thunks ================ //
const INCLUDE = ['customer', 'provider', 'listing', 'reviews'];

const fetchTransaction = id => (dispatch, getState, sdk) => {
  dispatch(fetchTxRequest());
  return sdk.transactions
    .show({ id, include: INCLUDE })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchTxSuccess({ id: response.data.data.id, type: 'transaction' }));
      return response;
    })
    .catch(e => {
      dispatch(fetchTxError(storableError(e)));
      throw e;
    });
};

export const loadData = params => dispatch => {
  const { id } = params || {};
  dispatch(setInitialValues({}));
  return dispatch(fetchTransaction(id));
};

/**
 * Perform an operator transition on the transaction. The server elevates an admin
 * session to the `operator` actor (server/api/transaction-transition.js), then
 * re-checks the actor against the state graph. On success we re-fetch the tx to
 * refresh its state + transition history.
 */
export const transitionTx = (txId, transitionName, params = {}) => (dispatch, getState, sdk) => {
  dispatch(transitionRequest(transitionName));
  return sdk.transactions
    .transition({ id: txId, transition: transitionName, params }, { expand: true })
    .then(() => {
      dispatch(transitionSuccess());
      return dispatch(fetchTransaction(txId));
    })
    .catch(e => {
      dispatch(transitionErrorAction(storableError(e)));
      throw e;
    });
};

export const sendSkeepers = txId => (dispatch, getState, sdk) => {
  return sdk.transactions.skeepersSend({ transactionId: txId }).then(res => {
    dispatch(fetchTransaction(txId));
    return res;
  });
};
